/*
  Le Petit Quché — corporate gifts page (sections lpq-corp-catalog, lpq-corp-inquiry).
  Vanilla JS, no dependencies of its own. Ported from design/corporate-gifts/index.html.
  - Flipbook: renders the catalog PDF itself with PDF.js (Mozilla, Apache-2.0), which is hosted in the
    store's Files and loaded only when the catalog section comes near the viewport. The PDF is linearized
    and the CDN answers range requests, so only the pages being looked at are downloaded. Two-page spread
    with a CSS 3D leaf turn (desktop), single page (< 640 px), arrow keys, instant swap under
    prefers-reduced-motion. If anything fails, the book is hidden and the „open PDF" buttons remain.
  - Zoom: „Увеличи" or a click on a page opens a full-screen dialog (appended to <body>) that re-renders the
    page from the PDF at 100–400 %; buttons, keys (Esc, arrows, +/-), double-click and mouse-drag panning.
  - Sticky mobile bar: hidden while the inquiry section is on screen.
  Loaded by more than one section, so it guards against running twice.
*/
(function () {
  if (window.__lpqcCorporate) return;
  window.__lpqcCorporate = true;

  var CACHE_MAX = 14; // rendered pages kept as object URLs

  // Load an ES module without writing import(): Shopify's asset minifier rewrites a dynamic
  // import() into require(), which does not exist in the browser. An injected module script is
  // a plain string to the minifier, so it survives.
  function loadModule(url) {
    return new Promise(function (resolve, reject) {
      var key = '__lpqcModule' + Date.now() + Math.floor(Math.random() * 1e6);
      var timer = setTimeout(function () { delete window[key]; reject(new Error('module timeout: ' + url)); }, 20000);
      window[key] = function (mod) { clearTimeout(timer); delete window[key]; resolve(mod); };
      var s = document.createElement('script');
      s.type = 'module';
      s.textContent = 'import * as m from ' + JSON.stringify(new URL(url, location.href).href) + ';window[' + JSON.stringify(key) + '](m);';
      document.head.appendChild(s);
    });
  }

  function initBook(book) {
    if (book.__lpqcReady) return;
    book.__lpqcReady = true;
    var pdfUrl = book.getAttribute('data-pdf'),
        libUrl = book.getAttribute('data-pdfjs'),
        workerUrl = book.getAttribute('data-pdfjs-worker');
    if (!pdfUrl || !libUrl || !workerUrl) return fail();

    var q = function (s) { return book.querySelector(s); };
    var L = q('[data-lpqc-left]'), R = q('[data-lpqc-right]'), leaf = q('[data-lpqc-leaf]'),
        F = q('[data-lpqc-front]'), B = q('[data-lpqc-back]'), status = q('[data-lpqc-status]'),
        prevs = book.querySelectorAll('[data-lpqc-prev]'), nexts = book.querySelectorAll('[data-lpqc-next]'),
        mobile = window.matchMedia('(max-width:639px)'),
        reduce = window.matchMedia('(prefers-reduced-motion: reduce)'),
        pdf = null, TOTAL = 0, right = 1, busy = true,
        cache = new Map(); // page number -> Promise<objectURL>

    function each(list, fn) { Array.prototype.forEach.call(list, fn); }
    function fail() {
      book.hidden = true;
      book.style.display = 'none'; // .lpqc-book sets display:grid, which would override [hidden]
      book.setAttribute('data-lpqc-failed', '');
    }
    function setButtons() {
      each(prevs, function (b) { b.disabled = busy || right <= 1; });
      each(nexts, function (b) { b.disabled = busy || right >= TOTAL; });
      if (zoomBtn) zoomBtn.disabled = !pdf;
    }
    var zoomBtn = q('[data-lpqc-zoom]');

    // Render page n to an object URL, sized for the current page box and screen density.
    function pageSrc(n) {
      if (n < 1 || n > TOTAL) return Promise.resolve('');
      if (cache.has(n)) {
        var hit = cache.get(n); cache.delete(n); cache.set(n, hit); // LRU touch
        return hit;
      }
      var p = pdf.getPage(n).then(function (page) {
        var base = page.getViewport({ scale: 1 });
        var box = R.parentNode.clientWidth || 600;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var scale = Math.min(1600, Math.ceil(box * dpr)) / base.width;
        var vp = page.getViewport({ scale: scale });
        var canvas = document.createElement('canvas');
        canvas.width = Math.ceil(vp.width); canvas.height = Math.ceil(vp.height);
        return page.render({ canvasContext: canvas.getContext('2d'), viewport: vp }).promise.then(function () {
          page.cleanup();
          return new Promise(function (res) {
            canvas.toBlob(function (blob) { res(blob ? URL.createObjectURL(blob) : ''); }, 'image/jpeg', 0.88);
          });
        });
      });
      cache.set(n, p);
      while (cache.size > CACHE_MAX) {
        var oldest = cache.keys().next().value;
        var old = cache.get(oldest); cache.delete(oldest);
        old.then(function (u) { if (u) URL.revokeObjectURL(u); });
      }
      return p;
    }
    function setImg(img, n) {
      return pageSrc(n).then(function (u) {
        if (u) { img.src = u; img.alt = 'Каталог, страница ' + n; } else { img.removeAttribute('src'); img.alt = ''; }
        img.parentNode.classList.toggle('lpqc-empty', !u);
      });
    }
    function label() {
      var left = right - 1;
      if (mobile.matches) return (right === 1 ? 'Корица · ' : 'Страница ') + right + ' от ' + TOTAL;
      return right === 1 ? 'Корица · 1 от ' + TOTAL : 'Страници ' + left + '–' + right + ' от ' + TOTAL;
    }
    function render() {
      var jobs = mobile.matches ? [setImg(R, right)] : [setImg(L, right - 1), setImg(R, right)];
      return Promise.all(jobs).then(function () {
        status.textContent = label();
        busy = false; setButtons();
        // warm the neighbours, one at a time
        [right + 1, right + 2, right - 1, right - 2].reduce(function (chain, n) {
          return chain.then(function () { return pageSrc(n); });
        }, Promise.resolve());
      });
    }
    function go(dir) {
      if (busy || !pdf) return;
      var target = right + dir * (mobile.matches ? 1 : 2);
      if (mobile.matches) {
        if (target < 1 || target > TOTAL) return;
        busy = true; setButtons(); right = target; render(); return;
      }
      if (dir > 0 && right >= TOTAL) return;
      if (dir < 0 && right <= 1) return;
      if (target > TOTAL) target = TOTAL;
      if (target < 1) target = 1;
      busy = true; setButtons();
      // make sure every face of the turn is rendered before the leaf moves
      Promise.all([pageSrc(right), pageSrc(right - 1), pageSrc(target), pageSrc(target - 1)]).then(function () {
        if (reduce.matches) { right = target; return render(); }
        var steps = dir > 0
          // right leaf turns left: front = current right page, back = next left page; underneath = next right page
          ? [setImg(F, right), setImg(B, target - 1), setImg(R, target)]
          // left leaf turns right: front = target right page, back = current left page; underneath = target left page
          : [setImg(F, target), setImg(B, right - 1), setImg(L, target - 1)];
        return Promise.all(steps).then(function () {
          leaf.className = 'lpqc-leaf lpqc-turning ' + (dir > 0 ? 'lpqc-fwd' : 'lpqc-bwd');
          var finished = false;
          var done = function () {
            if (finished) return; finished = true;
            leaf.className = 'lpqc-leaf'; leaf.removeEventListener('animationend', done);
            right = target; render();
          };
          leaf.addEventListener('animationend', done);
          setTimeout(done, 900);
        });
      }).catch(function () { busy = false; setButtons(); });
    }

    // ---------- Zoom: full-screen view of one page, re-rendered from the PDF at each level ----------
    var LEVELS = [1, 1.5, 2, 3, 4];
    var zEl = null, zScroll, zCanvas, zStatus, zBtns = {}, zPage = 1, zLevel = 0, zToken = 0,
        zLastFocus = null, zPrevOverflow = '', zResizeTimer = 0;

    function el(tag, cls, attrs, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (attrs) Object.keys(attrs).forEach(function (k) { n.setAttribute(k, attrs[k]); });
      if (text) n.textContent = text;
      return n;
    }
    function buildZoom() {
      zEl = el('div', 'lpq-corp lpqc-zoom', {
        role: 'dialog', 'aria-modal': 'true',
        'aria-label': (book.getAttribute('aria-label') || 'Каталог') + ' — увеличен изглед'
      });
      zEl.hidden = true;
      var bar = el('div', 'lpqc-zoom-bar');
      var btn = function (key, label, glyph) {
        zBtns[key] = el('button', 'lpqc-zoom-btn', { type: 'button', 'aria-label': label }, glyph);
        return zBtns[key];
      };
      zStatus = el('span', 'lpqc-zoom-status', { 'aria-live': 'polite' });
      bar.appendChild(btn('prev', 'Предишна страница', '‹'));
      bar.appendChild(zStatus);
      bar.appendChild(btn('next', 'Следваща страница', '›'));
      bar.appendChild(el('span', 'lpqc-zoom-sep', { 'aria-hidden': 'true' }));
      bar.appendChild(btn('out', 'Намали', '−'));
      bar.appendChild(btn('in', 'Увеличи', '+'));
      bar.appendChild(btn('close', 'Затвори', '×'));
      zScroll = el('div', 'lpqc-zoom-scroll');
      zCanvas = el('canvas', 'lpqc-zoom-canvas');
      zScroll.appendChild(zCanvas);
      zEl.appendChild(bar);
      zEl.appendChild(zScroll);
      document.body.appendChild(zEl); // outside the section: its transforms and filters would trap position:fixed
      zBtns.prev.addEventListener('click', function () { zoomPage(-1); });
      zBtns.next.addEventListener('click', function () { zoomPage(1); });
      zBtns['in'].addEventListener('click', function () { zoomBy(1); });
      zBtns.out.addEventListener('click', function () { zoomBy(-1); });
      zBtns.close.addEventListener('click', closeZoom);
      zEl.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closeZoom(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); zoomPage(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); zoomPage(-1); }
        else if (e.key === '+' || e.key === '=') { e.preventDefault(); zoomBy(1); }
        else if (e.key === '-' || e.key === '_') { e.preventDefault(); zoomBy(-1); }
        else if (e.key === 'Tab') { // keep focus inside the dialog
          var f = zEl.querySelectorAll('button:not([disabled])');
          if (!f.length) return;
          if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
          else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
        }
      });
      zScroll.addEventListener('dblclick', function () { zLevel = zLevel ? 0 : 2; drawZoom(); });
      // drag to pan with a mouse; touch keeps native scrolling
      var drag = null;
      zScroll.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        drag = { x: e.clientX, y: e.clientY, l: zScroll.scrollLeft, t: zScroll.scrollTop };
        zScroll.classList.add('lpqc-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        zScroll.scrollLeft = drag.l - (e.clientX - drag.x);
        zScroll.scrollTop = drag.t - (e.clientY - drag.y);
      });
      window.addEventListener('pointerup', function () { drag = null; zScroll.classList.remove('lpqc-dragging'); });
      window.addEventListener('resize', function () {
        if (zEl.hidden) return;
        clearTimeout(zResizeTimer); zResizeTimer = setTimeout(drawZoom, 150);
      });
    }
    function drawZoom() {
      var token = ++zToken, level = LEVELS[zLevel];
      zStatus.textContent = 'Страница ' + zPage + ' от ' + TOTAL + ' · ' + Math.round(level * 100) + ' %';
      zBtns.prev.disabled = zPage <= 1; zBtns.next.disabled = zPage >= TOTAL;
      zBtns.out.disabled = zLevel <= 0; zBtns['in'].disabled = zLevel >= LEVELS.length - 1;
      pdf.getPage(zPage).then(function (page) {
        if (token !== zToken) return;
        var base = page.getViewport({ scale: 1 }), aspect = base.width / base.height;
        var availW = zScroll.clientWidth - 32, availH = zScroll.clientHeight - 32;
        var fitW = Math.max(160, Math.min(availW, availH * aspect));
        var cssW = fitW * level, cssH = cssW / aspect;
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var vp = page.getViewport({ scale: Math.min(4096, Math.round(cssW * dpr)) / base.width });
        var c = el('canvas', 'lpqc-zoom-canvas', { role: 'img', 'aria-label': 'Каталог, страница ' + zPage });
        c.width = Math.ceil(vp.width); c.height = Math.ceil(vp.height);
        c.style.width = cssW + 'px'; c.style.height = cssH + 'px';
        return page.render({ canvasContext: c.getContext('2d'), viewport: vp }).promise.then(function () {
          if (token !== zToken) return;
          // keep the point in the middle of the view where it was
          var cx = zScroll.scrollWidth > zScroll.clientWidth ? (zScroll.scrollLeft + zScroll.clientWidth / 2) / zScroll.scrollWidth : 0.5;
          var cy = zScroll.scrollHeight > zScroll.clientHeight ? (zScroll.scrollTop + zScroll.clientHeight / 2) / zScroll.scrollHeight : 0.5;
          zScroll.replaceChild(c, zCanvas); zCanvas = c;
          zScroll.scrollLeft = cx * zScroll.scrollWidth - zScroll.clientWidth / 2;
          zScroll.scrollTop = cy * zScroll.scrollHeight - zScroll.clientHeight / 2;
          page.cleanup();
        });
      });
    }
    function zoomBy(d) {
      var n = Math.max(0, Math.min(LEVELS.length - 1, zLevel + d));
      if (n !== zLevel) { zLevel = n; drawZoom(); }
    }
    function zoomPage(d) {
      var n = zPage + d;
      if (n < 1 || n > TOTAL) return;
      zPage = n; zScroll.scrollTop = 0; zScroll.scrollLeft = 0; drawZoom();
    }
    function openZoom(n) {
      if (!pdf || n < 1 || n > TOTAL) return;
      if (!zEl) buildZoom();
      zPage = n; zLevel = 0; zLastFocus = document.activeElement;
      zEl.hidden = false;
      zPrevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      drawZoom();
      zBtns.close.focus();
    }
    function closeZoom() {
      if (!zEl || zEl.hidden) return;
      zToken++; zEl.hidden = true;
      document.documentElement.style.overflow = zPrevOverflow;
      if (zLastFocus && zLastFocus.focus) zLastFocus.focus();
    }
    if (zoomBtn) zoomBtn.addEventListener('click', function () {
      openZoom(mobile.matches ? right : Math.max(1, right - 1));
    });
    L.addEventListener('click', function () { if (!busy) openZoom(right - 1); });
    R.addEventListener('click', function () { if (!busy) openZoom(right); });

    function start() {
      status.textContent = 'Зареждане на каталога…';
      setButtons();
      loadModule(libUrl).then(function (lib) {
        lib.GlobalWorkerOptions.workerSrc = new URL(workerUrl, location.href).href;
        // 198 of the catalog's 218 images are JPEG 2000: PDF.js decodes them with openjpeg.wasm (and ICC colours
        // with qcms_bg.wasm), both uploaded to Settings → Files next to the library, i.e. the same folder.
        var wasmDir = new URL('./', new URL(libUrl, location.href)).href;
        return lib.getDocument({ url: pdfUrl, wasmUrl: wasmDir, disableAutoFetch: true, disableStream: true, rangeChunkSize: 262144 }).promise;
      }).then(function (doc) {
        pdf = doc; TOTAL = doc.numPages;
        return render();
      }).catch(fail);
    }

    each(nexts, function (b) { b.addEventListener('click', function () { go(1); }); });
    each(prevs, function (b) { b.addEventListener('click', function () { go(-1); }); });
    book.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
    });
    var onChange = function () {
      if (!pdf) return;
      if (!mobile.matches && right % 2 === 0 && right < TOTAL) { right += 1; }
      busy = true; setButtons(); render();
    };
    if (mobile.addEventListener) { mobile.addEventListener('change', onChange); } else { mobile.addListener(onChange); }

    setButtons();
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) { io.disconnect(); start(); }
      }, { rootMargin: '800px 0px' });
      io.observe(book);
    } else {
      start();
    }
  }

  function initSticky() {
    var sticky = document.querySelector('[data-lpqc-sticky]'), inq = document.getElementById('inquiry');
    if (!sticky || !inq || sticky.__lpqcReady || !('IntersectionObserver' in window)) return;
    sticky.__lpqcReady = true;
    new IntersectionObserver(function (en) { sticky.hidden = en[0].isIntersecting; }, { threshold: 0.15 }).observe(inq);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-lpqc-book]'), initBook);
    initSticky();
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
